import { createSelector } from 'reselect';
import getOptinState from './getOptinState';
import { RootState } from '../../../stores/types';
import { OptinState } from '../types';

export default createSelector<RootState, OptinState, string | undefined>(
  getOptinState,
  (optinState: OptinState) => optinState.activeOptinAttribute.optinAttributeKey,
);
